import SimpleAccordion from "qubCommon/Accordions/SimpleAccordion";
import "./LegalFiles.css";

const containerStyle = {
  padding: '20px',
  fontFamily: 'Arial, sans-serif',
  color: '#222',
};

const titleStyle = {
  fontSize: '22px',
  fontWeight: '700',
  marginBottom: '16px',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
};

const cellStyle = {
  border: '1px solid #666',
  padding: '12px 16px',
  verticalAlign: 'top',
  fontSize: '16px',
  lineHeight: '1.4',
};

const leftCellStyle = {
  ...cellStyle,
  width: '60%',
};

const rightCellStyle = {
  ...cellStyle,
  width: '40%',
  textAlign: 'right',
  fontWeight: '600',
  whiteSpace: 'nowrap',
};

const underlineBold = {
  fontWeight: '700',
  textDecoration: 'underline',
};

const LegalFiles = () => {
  return (
    <>
      <SimpleAccordion
        title={
          <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
            Νομοθετικό Πλαίσιο Προγράμματος
          </span>
        }
        content={
          <p>
            Το πρόγραμμα και οι όροι εφαρμογής του προσδιορίζονται βάσει της{" "}
            <a
              className=" ds-link small-font-size "
              href={"/lae-miteres/KYA.pdf"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Υπουργικής Απόφασης αριθ. 7826/2025 (ΦΕΚ 2636/Β/28-05-2025)
            </a>
            :
            <br />
            <strong>
              «Καθορισμός Προγραμμάτων του Λογαριασμού Αγροτικής Εστίας του
              ΟΠΕΚΑ (ΛΑΕ/ΟΠΕΚΑ), έτους 2025».
            </strong>
            <br />
            <br />
            Επιπλέον, το ποσό των χρηματικών βραβείων για τρίτεκνες και
            πολύτεκνες μητέρες καθορίζεται με απόφαση της Διαχειριστικής
            Επιτροπής του ΛΑΕ σύμφωνα με το άρθρο 3 του Ν.3050/2002. .
          </p>
        }
      />
      <br />
      <SimpleAccordion
        title={
          <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
            Πληροφορίες Δικαιούχων
          </span>
        }
        content={
          <p>
            <a
              className=" ds-link small-font-size "
              href={
                "https://opeka.gr/wp-content/uploads/2025/07/%CE%A0%CE%9B%CE%97%CE%A1%CE%9F%CE%A6%CE%9F%CE%A1%CE%99%CE%95%CE%A3-%CE%94%CE%99%CE%9A%CE%91%CE%99%CE%9F%CE%A5%CE%A7%CE%A9%CE%9D-%CE%A4%CE%A1%CE%99.-%CE%A0%CE%9F%CE%9B%CE%A5%CE%A4.-2025.-24-7-2025.pdf"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              Προγράμματος 5: Τρίτεκνες Πολύτεκνες Μητέρες
            </a>
            <br />
            <br />
            <a
              className=" ds-link small-font-size "
              href="https://opeka.gr/wp-content/uploads/2025/11/%CE%9F%CE%A1%CE%9F%CE%99-%CE%A5%CE%A0%CE%9F%CE%A4%CE%A1%CE%9F%CE%A6%CE%99%CE%A9%CE%9D_4.11.2025.pdf"


              target="_blank"
              rel="noopener noreferrer"
            >
              Προγράμματος 6: Υποτροφίες Επιτυχόντων Τέκνων Πανελλαδικών Εξετάσεων
            </a>
          </p>
        }
      />

      <br />
      <SimpleAccordion
        title={
          <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
            Κανόνες Επιλεξιμότητας Τέκνων Ωφελουμένων
          </span>
        }
        content={
          <div
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "1rem",
              lineHeight: "1.6",
              color: "#222",
            }}
          >
            <p>
              Τα τέκνα που λαμβάνονται υπόψη για τη χορήγηση της παροχής πρέπει να είναι{" "}
              <strong>άγαμα</strong> και <strong>άνεργα</strong> και:
            </p>

            <ul style={{ listStyleType: "disc", paddingLeft: "22px", marginTop: "10px" }}>
              <li style={{ marginBottom: "10px" }}>
                Να μην υπερβαίνουν το δέκατο όγδοο (18<sup>ο</sup>) έτος της ηλικίας τους,
                ή το δέκατο ένατο (19<sup>ο</sup>) έτος εφόσον συνεχίζουν τη φοίτησή τους
                στη μέση εκπαίδευση,
              </li>
              <li style={{ marginBottom: "10px" }}>
                Το εικοστό τέταρτο (24<sup>ο</sup>) έτος, εφόσον σπουδάζουν σε Ίδρυμα
                Ανώτατης ή Ανώτερης Εκπαίδευσης στην Ελλάδα ή στο εξωτερικό ή φοιτούν στο{" "}
                <strong>«Μεταλυκειακό έτος - Τάξη Μαθητείας»</strong> των Επαγγελματικών
                Λυκείων (ΕΠΑ.Λ.) ή σε Ινστιτούτα Επαγγελματικής Κατάρτισης (Ι.Ε.Κ),
              </li>
              <li style={{ marginBottom: "10px" }}>
                Να είναι παιδιά με ποσοστό αναπηρίας πενήντα τοις εκατό (50%) και άνω
                ανεξαρτήτως ηλικίας.
              </li>
            </ul>

            <p style={{ marginTop: "10px" }}>
              <strong>Προσδιορισμός ηλικίας τέκνων</strong>: Ως ημερομηνία συμπλήρωσης του{" "}
              18<sup>ου</sup>, 19<sup>ου</sup> και 24<sup>ου</sup> έτους ηλικίας
              θεωρείται η <strong>31η Δεκεμβρίου του έτους 2025</strong>, ανεξάρτητα
              από το μήνα γέννησης.
            </p>
          </div>
        }
      />
      <br />

      <SimpleAccordion
        title={
          <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
            Προθεσμίες Υποβολής Αιτήσεων
          </span>
        }
        content={
          <div style={containerStyle}>

            <table style={tableStyle}>
              <tbody>
                <tr>
                  <td style={leftCellStyle}>
                    <span style={underlineBold}>Πρόγραμμα 5:</span> Τρίτεκνες / Πολύτεκνες Μητέρες
                  </td>
                  <td style={rightCellStyle}>
                    28/07/2025 09:00 - 22/09/2025 23:59
                  </td>
                </tr>
                <tr>
                  <td style={leftCellStyle}>
                    <span style={underlineBold}>Πρόγραμμα 6:</span> Υποτροφίες Επιτυχόντων Τέκνων τους στις Πανελλαδικές Εξετάσεις (Νέο Πρόγραμμα)
                  </td>
                  <td style={rightCellStyle}>
                    10/11/2025 16:00 - 01/12/2025 23:59
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        }
      />
      <br />
      <SimpleAccordion
        title={
          <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
            Επεξεργασία Προσωπικών Δεδομένων των Αιτουσών Μητέρων
          </span>
        }
        content={
          <p>
            Με την υποβολή της αίτησης συμμετοχής παρέχεται η{" "}
            <strong>συγκατάθεση προς τον ΟΠΕΚΑ</strong> για την επεξεργασία
            προσωπικών δεδομένων του αιτούντος και των έμμεσων μελών του,
            αποκλειστικά για τους σκοπούς ένταξης στα Προγράμματα της παρούσας.
          </p>
        }
      />
      <br />

    </>
  );
};

export default LegalFiles;
